import { makeAutoObservable } from 'mobx'
import { EnumUserRoles, type Permissions } from 'entities/Users'
import { type IResponseInvite } from 'entities/Users/api/types'

export class Invite {
  id: string
  userId: number
  email: string
  role: EnumUserRoles | null
  roleLabel: string
  permissions: Permissions | null
  url: string
  createdAt: string
  organizationId: number

  constructor(item: IResponseInvite) {
    this.id = item.id
    this.userId = item.user_id
    this.email = item.email
    this.role = item.user?.role ?? null
    this.roleLabel = item.user?.role_label ?? ''
    const rawPermissions = item.user?.permissions ?? null
    this.permissions = Array.isArray(rawPermissions) ? null : rawPermissions
    this.url = item.url
    this.createdAt = item.created_at
    this.organizationId = item.organization_id

    makeAutoObservable(this)
  }

  get hasSeat() {
    return this.role !== null && this.role !== EnumUserRoles.VIEW_ONLY
  }
}
